import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  FaCaretDown,
  FaGlobe,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaWhatsapp,
  FaGithub,
  FaFacebook,
  FaSnapchat,
  FaPinterest,
  FaTelegram,
  FaVimeo,
  FaYelp,
  FaLine,
  FaFlickr,
  FaXing,
  FaTumblr,
  FaSpotify,
} from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { RiSendPlaneFill } from "react-icons/ri";
import { GrLinkPrevious, GrLinkNext } from "react-icons/gr";
import { IoCloseSharp } from "react-icons/io5";
import { TbWorldWww } from "react-icons/tb";
import { FaXTwitter } from "react-icons/fa6";


import { useNavigate, useParams } from "react-router-dom";
import no_user from "../public/assets/img/no_user.png";
import user from "../public/assets/img/user.png";
import Imupload from "../public/assets/img/Imupload.svg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Breadcrumb from "../Breadcrumb";
import { updateSubscriptionStatus } from "../../utils/subscription";
import DeleteConfirmationModal from "../DeleteConfirmationModal";
// import ReactCrop from "react-image-crop";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from 'react-image-crop'
import "react-image-crop/dist/ReactCrop.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const BusinessForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [activeColor, setActiveColor] = useState("#9f5ffe");
  const [contentType, setContentType] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [probId, setprobId] = useState(null);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState(null);
  const [success, setSuccess] = useState("");
  const [websites, setWebsites] = useState([""]);
  const [editId, setEditId] = useState(null);
  const [images, setImages] = useState([]);
  const [new_images, setNewImages] = useState([]);
  const [whatsappname, setWhatsappName] = useState("");
  const [mobile, setMobile] = useState("");
  const [message, setMessage] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [showLimitMessage, setShowLimitMessage] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [src, setSrc] = useState(null);
  const [crop, setCrop] = useState({ unit: "%", width: 50, height: 50, x: 25, y: 25 });
  const [croppedImage, setCroppedImage] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const imgRef = useRef(null);
  const [removedImages, setRemovedImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const hasCreatedBusiness = useRef(false);


  const [businessdata, setBusinessData] = useState({
    full_name: "",
    colour: "",
    img: "",
    img_content_type: "",
    phone: "",
    email: "",
    company_name: "",
    designation: "",
    address: "",
    websites: [""],
    note: "",
    links: [],
    image: [],

    youtube_link: "",

  });


  const [productdata, setProductData] = useState({
    business_id: "",
    title: "",
    flag: 0,
    description: "",
    image: null,
    img: ""
  });
  const [users, setUsers] = useState([]);
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const [isSocialMediaVisible, setIsSocialMediaVisible] = useState(false);
  // const [links, setSocialMediaLinks] = useState([
  //   { platform: "LinkedIn", link: "", },
  //   { platform: "GitHub", link: "", },
  // ]);
  const [links, setSocialMediaLinks] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isClicked, setIsClicked] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const fileInputRef = useRef(null);
  const [Uid, setUid] = useState("");
  const [lightness, setLightness] = useState(50);
  const [name, setName] = useState("");
  const [imageData, setImageData] = useState([]);
  const [isIconListVisible, setIsIconListVisible] = useState(false);
  const [isProductvisible, setIsProductVisible] = useState(false);
  const [isGalleryvisible, setIsGalleryVisible] = useState(false);
  const [isYouTubeVisible, setYouTubeVisible] = useState(false);
  const [globalSocialError, setGlobalSocialError] = useState("");
  const fullImageList = (Array.isArray(businessdata?.image) ? businessdata.image : []).concat(images);

  const [previewIndex, setPreviewIndex] = useState(null);
  const [touchStartX, setTouchStartX] = useState(null);
  const infoSectionRef = useRef(null);
  const websiteImageRefs = useRef([]);
  const [faviconErrors, setFaviconErrors] = useState({});
  const [zoomLevel, setZoomLevel] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const containerRef = useRef(null);
  const imageRef = useRef(null);

  const maxZoom = 3;
  const minZoom = 1;

  const zoomIn = () => setZoomLevel((z) => Math.min(z + 0.1, maxZoom));
  const zoomOut = () => setZoomLevel((z) => Math.max(z - 0.1, minZoom));

  useEffect(() => {
    setZoomLevel(1);
    setRotation(0);
    setOffset({ x: 0, y: 0 });
  }, [previewIndex]);

  // For profile image crop
  function onImageLoad(e) {
    const { naturalWidth: width, naturalHeight: height } = e.currentTarget
    const crop = centerCrop(
      makeAspectCrop(
        {
          unit: '%',
          width: 90,
        },
        1 / 1,
        width,
        height
      ),
      width,
      height
    )
    setCrop(crop)
  }

  const clampDrag = (offsetX, offsetY) => {
    const container = containerRef.current;
    const image = imageRef.current;

    if (!container || !image) return { x: offsetX, y: offsetY };

    const containerRect = container.getBoundingClientRect();
    const scaledWidth = image.naturalWidth * zoomLevel;
    const scaledHeight = image.naturalHeight * zoomLevel;

    const excessX = Math.max(0, (scaledWidth - containerRect.width) / 2);
    const excessY = Math.max(0, (scaledHeight - containerRect.height) / 2);

    const clampedX = Math.min(Math.max(offsetX, -excessX), excessX);
    const clampedY = Math.min(Math.max(offsetY, -excessY), excessY);

    return { x: clampedX, y: clampedY };
  };

  const onMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setDragStart({ x: e.clientX, y: e.clientY });
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;

    const deltaX = e.clientX - dragStart.x;
    const deltaY = e.clientY - dragStart.y;
    const newOffset = { x: offset.x + deltaX, y: offset.y + deltaY };

    const clamped = clampDrag(newOffset.x, newOffset.y);
    setOffset(clamped);
    setDragStart({ x: e.clientX, y: e.clientY });
  };

  const onMouseUp = () => setIsDragging(false);

  const handleWheel = (e) => {
    e.preventDefault();
    if (e.deltaY < 0) zoomIn();
    else zoomOut();
  };

  const showPreviousImage = () => {
    setPreviewIndex((prev) => {
      if (prev === null) return fullImageList.length - 1;
      return prev === 0 ? fullImageList.length - 1 : prev - 1;
    });
  };

  const showNextImage = () => {
    setPreviewIndex((prev) => {
      if (prev === null) return 0;
      return prev === fullImageList.length - 1 ? 0 : prev + 1;
    });
  };

  const rotateLeft = () => setRotation((prevRotation) => prevRotation - 90);
  const rotateRight = () => setRotation((prevRotation) => prevRotation + 90);

  const transformStyle = {
    transform: `rotate(${rotation}deg) scale(${zoomLevel}) translate(${offset.x}px, ${offset.y}px)`,
    cursor: isDragging ? 'grabbing' : 'grab',
    transition: isDragging ? 'none' : 'transform 0.2s ease-out',
  };

  const handleSectionToggle = (section) => {
    if (section === "info") {
      setIsInfoVisible(!isInfoVisible);
      setIsSocialMediaVisible(false);
      setIsGalleryVisible(false);
      setYouTubeVisible(false);
      setIsProductVisible(false);
    } else if (section === "social") {
      setIsSocialMediaVisible(!isSocialMediaVisible);
      setIsInfoVisible(false);
      setIsGalleryVisible(false);
      setYouTubeVisible(false);

      setIsProductVisible(false);
    } else if (section === "product") {
      setIsProductVisible(!isProductvisible);
      setIsInfoVisible(false);
      setIsSocialMediaVisible(false);
      setIsIconListVisible(false);
      setIsGalleryVisible(false);
      setYouTubeVisible(false);
    } else if (section === "gallery") {
      setIsGalleryVisible(!isGalleryvisible);
      setIsInfoVisible(false);
      setIsSocialMediaVisible(false);
      setIsIconListVisible(false);
      setIsProductVisible(false);
      setYouTubeVisible(false);
    } else if (section === "youtube") {
      setYouTubeVisible(!isYouTubeVisible);
      setIsInfoVisible(false);
      setIsSocialMediaVisible(false);
      setIsIconListVisible(false);
      setIsProductVisible(false);
      setIsGalleryVisible(false);
    }
  };

  const resetForm = () => {
    setProductData({
      title: "",
      description: "",
      flag: 0,
      image: null,
      img: "",
      business_id: "",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    setFormErrors({});
    setEditId(null);
    setError(null);
    setSuccess("");
    setSubmitted(false);
  };

  const colorList = [
    { name: "Red", value: "red", code: "#FF0000" },
    { name: "Green", value: "green", code: "#008000" },
    { name: "Blue", value: "blue", code: "#0000FF" },
    { name: "Purple", value: "purple", code: "#800080" },
    { name: "Orange", value: "orange", code: "#FFA500" },
    { name: "Pink", value: "pink", code: "#D5006D" },
    { name: "Indigo", value: "indigo", code: "#4B0082" },
  ];

  useEffect(() => {
    if (isModalOpen) {
      document.body.classList.add("modal-open-bg-freeze");
    } else {
      document.body.classList.remove("modal-open-bg-freeze");
    }
  }, [isModalOpen]);

  const platformData = {
    Website: {
      label: "Website:",
      placeholder: "www.mywebsite.com",
      icon: <FaGlobe style={{ color: "#000", fontSize: "30px" }} />,
    },
    Twitter: {
      label: "Twitter:",
      placeholder: "www.twitter.com/username",
      icon: <FaXTwitter style={{ color: "#000000", fontSize: "30px" }} />,
    },
    Instagram: {
      label: "Instagram:",
      placeholder: "https://instagram.com/username",
      icon: <FaInstagram style={{ color: "#C13584", fontSize: "30px" }} />,
    },
    LinkedIn: {
      label: "LinkedIn:",
      placeholder: "www.linkedin.com/in/username",
      icon: <FaLinkedin style={{ color: "#0077B5", fontSize: "30px" }} />,
    },
    YouTube: {
      label: "YouTube:",
      placeholder: "https://youtube.com/channel/username",
      icon: <FaYoutube style={{ color: "#FF0000", fontSize: "30px" }} />,
    },
    WhatsApp: {
      label: "WhatsApp:",
      placeholder: "+12025550141",
      icon: <FaWhatsapp style={{ color: "#25D366", fontSize: "30px" }} />,
    },
    GitHub: {
      label: "GitHub:",
      placeholder: "https://github.com/username",
      icon: <FaGithub style={{ color: "#333", fontSize: "30px" }} />,
    },
    Facebook: {
      label: "Facebook:",
      placeholder: "https://facebook.com/username",
      icon: <FaFacebook style={{ color: "#3b5998", fontSize: "30px" }} />,
    },
    Snapchat: {
      label: "Snapchat:",
      placeholder: "www.snapchat.com/username",
      icon: <FaSnapchat style={{ color: "#FFFC00", fontSize: "30px" }} />,
    },
    Pinterest: {
      label: "Pinterest:",
      placeholder: "www.pinterest.com/username",
      icon: <FaPinterest style={{ color: "#E60023", fontSize: "30px" }} />,
    },
    Telegram: {
      label: "Telegram:",
      placeholder: "www.telegram.com/username",
      icon: <FaTelegram style={{ color: "#0088CC", fontSize: "30px" }} />,
    },
    Vimeo: {
      label: "Vimeo:",
      placeholder: "www.vimeo.com/channels",
      icon: <FaVimeo style={{ color: "#1AB7EA", fontSize: "30px" }} />,
    },
    Yelp: {
      label: "Yelp:",
      placeholder: "www.yelp.com/user_details/username",
      icon: <FaYelp style={{ color: "#D32323", fontSize: "30px" }} />,
    },
    Line: {
      label: "Line:",
      placeholder: "www.line.com/username",
      icon: <FaLine style={{ color: "#00B900", fontSize: "30px" }} />,
    },
    Flickr: {
      label: "Flickr:",
      placeholder: "www.flickr.com/people/username",
      icon: <FaFlickr style={{ color: "#FF0084", fontSize: "30px" }} />,
    },
    Xing: {
      label: "Xing:",
      placeholder: "www.xing.com/profile/username",
      icon: <FaXing style={{ color: "#F83F3F", fontSize: "30px" }} />,
    },
    Tumblr: {
      label: "Tumblr:",
      placeholder: "https://username.tumblr.com/",
      icon: <FaTumblr style={{ color: "#36465D", fontSize: "30px" }} />,
    },
    Spotify: {
      label: "Spotify:",
      placeholder: "open.spotify.com/user/username",
      icon: <FaSpotify style={{ color: "#1DB954", fontSize: "30px" }} />,
    },
  };

  useEffect(() => {
    document.documentElement.style.setProperty("--theme-vcard", activeColor);
  }, [activeColor]);

  const handleColorSelect = (color) => {
    setActiveColor(color);
    setLightness(50);
    setBusinessData((prevData) => ({
      ...prevData,
      colour: color,
    }));
    document.documentElement.style.setProperty("--theme-vcard", color);
  };

  const handleSliderChange = (e) => {
    const newLightness = e.target.value;
    setLightness(newLightness);

    const hslColor = hexToHSL(activeColor, newLightness);
    const hexColor = hslToHex(hslColor);

    setBusinessData((prevData) => ({
      ...prevData,
      colour: hexColor,
    }));

    document.documentElement.style.setProperty("--theme-vcard", hexColor);
  };

  const hexToHSL = (hex, lightness) => {
    let r = parseInt(hex.substring(1, 3), 16);
    let g = parseInt(hex.substring(3, 5), 16);
    let b = parseInt(hex.substring(5, 7), 16);

    r /= 255;
    g /= 255;
    b /= 255;

    let max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      let d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h *= 60;
    }

    return `hsl(${Math.round(h)}, ${Math.round(s * 100)}%, ${lightness}%)`;
  };
  const hslToHex = (hsl) => {
    let [h, s, l] = hsl.match(/\d+/g).map(Number);
    s /= 100;
    l /= 100;

    let c = (1 - Math.abs(2 * l - 1)) * s;
    let x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    let m = l - c / 2;
    let r, g, b;

    if (h < 60) [r, g, b] = [c, x, 0];
    else if (h < 120) [r, g, b] = [x, c, 0];
    else if (h < 180) [r, g, b] = [0, c, x];
    else if (h < 240) [r, g, b] = [0, x, c];
    else if (h < 300) [r, g, b] = [x, 0, c];
    else[r, g, b] = [c, 0, x];

    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);

    return `#${((1 << 24) | (r << 16) | (g << 8) | b)
      .toString(16)
      .slice(1)
      .toUpperCase()}`;
  };
  const handleFlagChange = (e) => {
    const value = e.target.value === "product" ? 0 : 1;
    setProductData({ ...productdata, flag: value });
  };

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   if (!token) {
  //     navigate("/");
  //     return;
  //   }

  //   const handleBusinessSetup = async () => {
  //     let businessId = id;

  //     if (businessId) {
  //       try {
  //         const response = await fetch(`${API_BASE_URL}get-business/${id}`, {
  //           headers: { Authorization: `Bearer ${token}` },
  //         });


  //         if (response.ok) {
  //           const data = await response.json();

  //           businessId = data.id;
  //           const dataIconLinks = data.serialized_business.links.filter(item => item.link && item.link.trim() !== "");
  //           setSocialMediaLinks(dataIconLinks || []);
  //           setActiveColor(data.serialized_business.colour);
  //           setprobId(businessId);

  //           const serialized = data.serialized_business;
  //           const imageKeys = ['image1', 'image2', 'image3', 'image4', 'image5'];
  //           const images = imageKeys.map(key => serialized[key]).filter(Boolean);
  //           serialized.image = images;
  //           setBusinessData(serialized);
  //         } else {

  //           throw new Error("Failed to fetch business data");
  //         }
  //       } catch (err) {
  //         console.error(err);
  //         setError("Failed to fetch existing business data");
  //       }
  //     } else {
  //       const business_id = localStorage.getItem("business_id") || null;
  //       businessId = business_id;

  //       if (business_id === null) {
  //         businessId = await createBusiness();
  //       }

  //       if (businessId) {
  //         setprobId(businessId);
  //       }
  //     }

  //     if (businessId) {
  //       fetchUser(businessId);
  //     }
  //   };
  //   handleBusinessSetup();
  //   // createBusiness();
  // }, [id]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }

    const handleBusinessSetup = async () => {
      let businessId = id;

      if (businessId) {
        try {
          const response = await fetch(`${API_BASE_URL}get-business/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });


          if (response.ok) {
            const data = await response.json();

            businessId = data.id;
            const dataIconLinks = data.serialized_business.links.filter(item => item.link && item.link.trim() !== "");
            setSocialMediaLinks(dataIconLinks || []);
            setActiveColor(data.serialized_business.colour);
            setprobId(businessId);

            const serialized = data.serialized_business;
            const imageKeys = ['image1', 'image2', 'image3', 'image4', 'image5'];
            const images = imageKeys.map(key => serialized[key]).filter(Boolean);
            serialized.image = images;
            setBusinessData(serialized);
          } else {

            throw new Error("Failed to fetch business data");
          }
        } catch (err) {
          console.error(err);
          setError("Failed to fetch existing business data");
        }
      } else {
        const storedBusinessId = localStorage.getItem("business_id");
        if (!storedBusinessId && !hasCreatedBusiness.current) {
          hasCreatedBusiness.current = true;
          businessId = await createBusiness();
        } else {
          businessId = storedBusinessId;
        }

        if (businessId) {
          setprobId(businessId);
        }
      }
      if (businessId) {
        fetchUser(businessId);
      }


    };
    handleBusinessSetup();

  }, [id]);
  // const createBusiness = async () => {
  //   const token = localStorage.getItem("token");
  //   if (!token) {
  //     navigate("/");
  //     return null;
  //   }
  //   try {
  //     const response = await fetch(`${API_BASE_URL}add-business`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         Accept: "application/json, text/plain,*/*",
  //       },
  //       body: {},
  //     });
  //     const data = await response.json();
  //     console.log("data-----", data)
  //     if (response.ok) {

  //       const businessId = data.id;
  //       localStorage.setItem('business_id', businessId)
  //       setUid(businessId);
  //       setprobId(businessId);
  //       fetchUser(businessId);
  //       return businessId;
  //     } else {
  //       if (data.message === "Your Digital Vcard genration limit is reach") {
  //         console.log("vcard toast msg")
  //         toast.error(data.message);
  //         return null;
  //       }
  //       throw new Error("Failed to create business");
  //     }
  //   } catch (err) {
  //     setError("Error creating business");
  //     console.log("error msg", err)
  //     return null;
  //   }
  // };

  const createBusiness = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return null;
    }
    try {
      const response = await fetch(`${API_BASE_URL}add-business`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain,*/*",
        },
        body: {},
      });
      let data;
      try {
        data = await response.clone().json();
      } catch (jsonError) {
        const fallbackText = await response.text();
        console.error("Could not parse JSON. Fallback response:", fallbackText);

        // Handle case where backend returns plain text or HTML
        toast.error("Something went wrong. Please try again.");
        return null;
      }
      console.log("data-----", data)
      if (response.ok) {

        const businessId = data.id;
        localStorage.setItem('business_id', businessId)
        setUid(businessId);
        setprobId(businessId);
        fetchUser(businessId);
        return businessId;
      } else {
        const message = data?.message || "Failed to create business";
        toast.error(message);
        return null;
      }
    } catch (err) {
      setError("Error creating business");
      console.log("error msg", err)
      return null;
    }
  };
  const _onlyNumber = (e) => {
    const re = /^[0-9]$/;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  };
  const handleFaviconError = (index) => {
    setFaviconErrors((prev) => ({ ...prev, [index]: true }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess("");
    setFormErrors({});
    setSubmitted(false);
    setGlobalSocialError("");

    let errors = {};

    if (!businessdata.full_name || !businessdata.full_name.trim()) {
      errors.full_name = "Full Name is required.";
    }
    if (businessdata.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(businessdata.email)) {
      errors.email = "Invalid email format.";
    }

    // if (Object.keys(errors).length > 0) {
    //   setFormErrors(errors);
    //   setLoading(false);
    //   return;
    // }
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setLoading(false);

      setIsInfoVisible(true);
      if (infoSectionRef.current) {
        infoSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }

      return;
    }

    const updatedImages = [...images]

    const validLinks = links.filter(item => item.link && item.link.trim() !== "");
    const updatedBusinessData = {
      ...businessdata, links: validLinks,
      images: updatedImages.map(img => img.name), deletedImages: deletedImages
    };



    const formData = new FormData();
    formData.append("businessdata", JSON.stringify(updatedBusinessData));

    if (businessdata.image) {
      formData.append("image", businessdata.image);
    }

    // images.forEach((img, index) => {
    //   if (index < 5) {
    //     formData.append(`image${index + 1}`, img);
    //   }
    // });

    updatedImages.forEach((img, index) => {
      let itemIndex = (index + 1);
      formData.append(`image${businessdata.image.length + itemIndex}`, img); // send files separately
    });

    // if (removedImages.length > 0) {
    //   formData.append("removed_images", JSON.stringify(removedImages));
    // }


    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }

    let response;
    let formId = probId;
    try {
      if (formId) {
        response = await fetch(`${API_BASE_URL}update-business/${formId}`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json, text/plain,*/*",
          },
          body: formData,
        });
      }

      if (response.ok) {
        const data = await response.json();
        setName(data.name);

        toast.success(
          id ? "Business updated successfully!" : "Business added successfully!"
        );
        setSubmitted(true);


        // if (id) {
        //   setTimeout(() => {
        //     navigate(`/vcards`);
        //     localStorage.removeItem("business_id");
        //   }, 2000);
        // }

        setTimeout(() => {
          navigate(`/vcards`);
          localStorage.removeItem("business_id");
        }, 2000);
        return;

        // setTimeout(() => {
        //   localStorage.removeItem("business_id");
        //   navigate("/vcards", {
        //     state: {
        //       toastMessage: id
        //         ? "Business updated successfully!"
        //         : "Business added successfully!",
        //     },
        //   });
        // }, 1000);


      } else {
        const data = await response.json();
        if (data.status === 'Success') {
          navigate(`/vcards`)
        }
        if (data.message) {

          if (
            data.message.includes(
              "Only 3 businesses with the same name are allowed"
            )
          ) {
            toast.error(
              "You can create up to 3 vCards only. Please delete an existing one if you need to add a new vCard."
            );
          } else {
            try {
              const parsedErrors = JSON.parse(data.message.replace(/'/g, '"'));
              setFormErrors(parsedErrors);
            } catch (err) {
              setError(id ? "Error updating business." : "Error creating business.");
            }
          }
        } else {
          throw new Error("Failed to submit business data");
        }
      }
    } catch (err) {
      setError(id ? "Error updating business." : "Error creating business.");
    }
  };


  const handlePublish = async (id, name) => {
    try {
      if (name) {
        navigate(`/vcard/${name}`, { state: { id } });
      } else {
        toast.warning("Please submit the form before publishing.");
      }
    } catch (error) {
      console.error("Error in handlePublish:", error);
    }
  };

  // const handleImageUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setBusinessData((prevData) => ({
  //       ...prevData,
  //       image: file,
  //       img: URL.createObjectURL(file),
  //     }));
  //   }
  // };
  // const handleImageUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setSrc(reader.result);
  //       setShowCropModal(true);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSrc(reader.result);
        setShowCropModal(true);
      };
      reader.readAsDataURL(file);
      event.target.value = null;
    }
  };


  const getCroppedImg = (image, crop) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        const file = new File([blob], "cropped-image.jpg", { type: "image/jpeg" });
        resolve({ file, url: URL.createObjectURL(file) });
      }, "image/jpeg");
    });
  };

  const handleCropComplete = async () => {
    if (imgRef.current && crop.width && crop.height) {
      const { file, url } = await getCroppedImg(imgRef.current, crop);
      setBusinessData((prevData) => ({
        ...prevData,
        image: file,
        img: url,
      }));
      setShowCropModal(false);
      setCroppedImage(url);
    }
  };


  const handleProductImageUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      setProductData((prevData) => ({
        ...prevData,
        image: file,
        img: URL.createObjectURL(file),
      }));
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        img: "",
      }));
    }
  };
  const formatCompanyURL = (name) => {
    if (!name) return '#';
    if (name.startsWith("http://") || name.startsWith("https://")) {
      return name;
    }
    if (name.includes('.') && !name.includes(' ')) {
      return `https://${name}`;
    }
    const searchQuery = encodeURIComponent(name);
    return `https://www.google.com/search?q=${searchQuery}`;
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBusinessData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "full_name" && formErrors.full_name) {
      setFormErrors({
        ...formErrors,
        full_name: [],
      });
    }
    if (name === "email" && formErrors.email) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
    }
  };

  const handleWebsiteChange = (index, e) => {
    console.log(
      "Input changed for index:",
      index,
      "New value:",
      e.target.value
    );
    const updatedWebsites = [...businessdata.websites];
    updatedWebsites[index] = e.target.value;
    setBusinessData((prevData) => {
      const newData = {
        ...prevData,
        websites: updatedWebsites,
      };
      console.log("Updated websites in state:", newData.websites);
      return newData;
    });
  };

  const handleRemoveWebsite = (index) => {
    setBusinessData((prevBusinessData) => ({
      ...prevBusinessData,
      websites: prevBusinessData.websites.filter((_, i) => i !== index),
    }));
  };

  const addWebsiteField = () => {
    setBusinessData((prevData) => ({
      ...prevData,
      websites: [...prevData.websites, ""],
    }));
  };

  const addSocialMediaLink = (platform) => {
    setIsClicked(true);

    setSocialMediaLinks((prevLinks) => {
      const exists = prevLinks.find((link) => link.platform === platform);

      if (exists) {

        return prevLinks.filter((link) => link.platform !== platform);
      } else {

        const newLink = {
          platform: platform,
          link: "",
          placeholder: platformData[platform].placeholder,
        };
        return [...prevLinks, newLink];
      }
    });
  };

  const handleSocialMediaChange = (index, value) => {
    const updatedLinks = [...links];
    updatedLinks[index].link = value;
    setSocialMediaLinks(updatedLinks);

    // if (formErrors[`link_${index}`]) {
    //   const updatedErrors = { ...formErrors };
    //   delete updatedErrors[`link_${index}`];
    //   setFormErrors(updatedErrors);
    // }
    const hasEmptyLinks = updatedLinks.some((link) => !link.link.trim());
    if (!hasEmptyLinks) {
      setGlobalSocialError("");
    }
  };

  const removeSocialMediaLink = (index) => {
    setSocialMediaLinks((prevLinks) => prevLinks.filter((_, i) => i !== index));

    if (links.length === 1) {
      setIsClicked(false);
    }
  };
  const toggleIconList = () => {
    setIsIconListVisible((prev) => !prev);
  };

  const iconStyles = {
    marginLeft: "10px",
    cursor: "pointer",
  };

  const handleIpChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "title" && formErrors.title) {
      setFormErrors({
        ...formErrors,
        title: [],
      });
    }
  };

  const fetchUser = async (businessId) => {
    const token = localStorage.getItem("token");
    const business_id = localStorage.getItem("business_id");

    if (!token) {
      navigate("/");
      return;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}get-product-services`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { business_id: businessId || business_id },
      });
      if (Array.isArray(response.data.data)) {
        setUsers(response.data.data);
        setFilteredUsers(response.data.data);
      } else {
        setUsers([]);
        console.error("Response data.data is not an array");
      }
    } catch (err) {
      if (
        err.response &&
        err.response.status === 403 &&
        err.response.data.login_subscription === "Expired"
      ) {

        updateSubscriptionStatus("Expired");
        window.dispatchEvent(new Event("storage"));
        return;
      }
      setError("Failed to fetch business data. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const submitProduct = async (formData, token) => {
    const response = await fetch(`${API_BASE_URL}add-product-service`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json, text/plain,*/*",
      },
      body: formData,
    });
    return response;
  };

  const updateProduct = async (id, formData, token) => {
    const response = await fetch(`${API_BASE_URL}update-product-service/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json, text/plain,*/*",
      },
      body: formData,
    });
    return response;
  };

  const handleProduct = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess("");
    setFormErrors({});
    setSubmitted(false);

    let errors = {};
    if (!productdata.title || productdata.title.trim() === "") {
      errors.title = "Title is required";
    }

    if (!productdata.img || productdata.img.trim() === "") {
      errors.img = "Image is required";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("title", productdata.title);
    formData.append("description", productdata.description);
    formData.append("flag", productdata.flag);
    formData.append("image", productdata.image);
    formData.append("business_id", probId);

    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }

    try {
      const response = editId
        ? await updateProduct(editId, formData, token)
        : await submitProduct(formData, token);

      if (response.ok) {
        const data = await response.json();
        setUid(data.id);
        setName(data.name);
        toast.success(editId ? "Product updated successfully!" : "Product added successfully!");

        fetchUser(data.b_id);

        resetForm();
        setIsModalOpen(false);

      } else {
        const data = await response.json();
        if (data.message) {
          try {
            const parsedErrors = JSON.parse(data.message.replace(/'/g, '"'));
            setFormErrors(parsedErrors);
          } catch (err) {
            setError(editId ? "Error updating product." : "Error creating product.");
          }
        } else {
          throw new Error("Failed to submit product data");
        }
      }
    } catch (err) {
      console.error("API Error:", err.message);
      setError(editId ? "Error updating product." : "Error creating product.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (id) => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }
    try {
      const response = await fetch(`${API_BASE_URL}get-product-service/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        const data = await response.json();

        setProductData({
          title: data.product.title,
          flag: data.product.flag,
          description: data.product.description,
          image: null,
          img: data.product.img,
          business_id: data.product.business_id,
        });

        setEditId(id);
        setFormErrors({});
        setError(null);
      }
    } catch (err) {
      console.error("Error fetching product for edit:", err);
    }
  };


  const openDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    const token = localStorage.getItem("token");
    try {
      await axios.delete(`${API_BASE_URL}/delete-product-service/${itemToDelete}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(users.filter((user) => user.id !== itemToDelete));
      setFilteredUsers(filteredUsers.filter((user) => user.id !== itemToDelete));
      toast.success("Product deleted Successfully");
    } catch (error) {
      setError("Error deleting product. Please try again.");
    } finally {
      closeDeleteModal();
    }
  };

  const handleDeleteAll = (event) => {
    event.preventDefault();
    setImages([]);
    setDeletedImages([]);
    setBusinessData(prev => ({ ...prev, image: [] }));

  };

  useEffect(() => {
    if (showDeleteModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [showDeleteModal]);

  useEffect(() => {
    if (isModalOpen) {
      document.body.classList.add("modal-open-bg-freeze");
    } else {
      document.body.classList.remove("modal-open-bg-freeze");
    }
  }, [isModalOpen]);

  const handleImageChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const totalCount = businessdata.image.length + selectedFiles.length;

    if (totalCount > 5) {
      alert("Maximum 5 images allowed.");
      return;
    }

    setImages((prev) => [...prev, ...selectedFiles]);
  };

  const handleRemoveImage = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);

  };
  const handleRemoveUpdatedImage = (index, imgUrl) => {

    const updatedImages = [...businessdata.image];
    updatedImages.splice(index, 1);

    setDeletedImages(prev => [...prev, imgUrl]);
    setBusinessData(prev => ({ ...prev, image: updatedImages }));
  };


  const handleAddImagesClick = () => {
    fileInputRef.current.click();
  };


  const getYoutubeVideoId = (url) => {
    if (!url) return null;
    const regex =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const videoId = getYoutubeVideoId(businessdata.youtube_link);

  const handleWhatsapp = (e) => {
    e.preventDefault();

    const mobileWithCode = `91${businessdata.phone}`;

    const fullMessage = `Name: ${whatsappname}%0AMobile: ${mobile}%0AMessage: ${message}`;

    const whatsappLink = `https://wa.me/${mobileWithCode}?text=${fullMessage}`;

    window.open(whatsappLink, "_blank");
    setWhatsappName('');
    setMobile('');
    setMessage('');
  };
  const handleMobileChange = (e) => {
    const value = e.target.value;

    if (/^\d{0,10}$/.test(value)) {
      setMobile(value);

      if (value.length === 10) {
        setMobileError("");
      } else {
        setMobileError("Mobile number must be exactly 10 digits");
      }
    } else {
      setMobile(value);
      setMobileError("Only numbers are allowed");
    }
  };

  const isFormValid =
    whatsappname.trim() !== "" &&
    message.trim() !== "" &&
    /^\d{10}$/.test(mobile);

  const handleImageClick = (index) => {
    setPreviewIndex(index);
  };

  const closePreview = () => {
    setPreviewIndex(null);
  };

  const goNext = () => {
    setPreviewIndex((prev) => (prev + 1) % fullImageList.length);
  };

  const goPrev = () => {
    setPreviewIndex((prev) => (prev - 1 + fullImageList.length) % fullImageList.length);
  };

  useEffect(() => {
    document.body.style.overflow = previewIndex !== null ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [previewIndex]);

  const handleTouchStart = (e) => setTouchStartX(e.changedTouches[0].clientX);
  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;
    if (diff > 50) goNext();
    if (diff < -50) goPrev();
    setTouchStartX(null);
  };

  const currentImg = fullImageList[previewIndex];
  const currentSrc = currentImg && (typeof currentImg === "string" ? currentImg : URL.createObjectURL(currentImg));

  const routes = [
    { name: "Home", path: "/dashboard" },
    { name: "Business", path: "/vcards" },
    id
      ? { name: "Update", path: "/update" }
      : { name: "Create", path: "/create" },
  ];


  return (
    <>
      <div className="container-fluid mx-auto">
        <div className="d-flex flex-column py-2" id="business-form">
          <div className="d-flex">
            <Breadcrumb routes={routes} />
          </div>

          <div className="row">
            <div className="col-sm-7 main-form">
              <div className="d-flex flex-column">
                <div>
                  <form onSubmit={handleSubmit}>
                    <div className="accordion-group white-box-shadow">
                      <div className="accordion my-4 border-bottom">
                        <div
                          className="d-flex title"
                          onClick={() => handleSectionToggle("color")}
                        >
                          <h3 className="accordion-title">
                            Design & Customize Your vCard
                          </h3>
                        </div>


                        <div className="form-content border-top-title color-container">
                          <h5 htmlFor="color">Choose a color:</h5>
                          <div className="row align-items-center input-unset">
                            <div className="Current-col">
                              <div className="d-flex flex-column w-100">
                                <div className="alphapicker pb-1 rounded-4">

                                  {/* Slider - Darker to Lighter */}
                                  <div className="color-slider w-100 rounded-5 px-1 cursor-pointer"
                                    style={{ background: `linear-gradient(to right, black, ${activeColor}, white)`, }}>
                                    <input
                                      type="range"
                                      id="color-picker"
                                      className="color-picker rounded form-range w-100"
                                      min="0"
                                      max="100"
                                      step="1"
                                      value={lightness}
                                      onChange={handleSliderChange}
                                      style={{
                                        height: "12px",
                                        borderRadius: "5px",
                                        outline: "none",
                                        appearance: "none",
                                      }}
                                    />
                                  </div>

                                  <div className="custom-color-picker-outer color-picker cursor-pointer ms-3">
                                    <input
                                      className="custom-color-picker"
                                      type="color"
                                      value={activeColor}
                                      onChange={(e) =>
                                        handleColorSelect(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>

                                <ul className="flex flex-wrap round-gap ps-0">
                                  {colorList.map((item, index) => (
                                    <div className="color-box-outer">
                                      <div
                                        key={index}
                                        className="color-box rounded cursor-pointer"
                                        style={{ backgroundColor: item.code }}
                                        onClick={() =>
                                          handleColorSelect(item.code)
                                        }
                                        value={businessdata.colour}
                                      ></div>
                                    </div>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div className="accordion my-4 border-bottom user-input-form" ref={infoSectionRef}>
                        <div
                          className="d-flex title"
                          onClick={() => handleSectionToggle("info")}
                        >
                          <h3 className="accordion-title">Your Information</h3>
                          <h3 className="ms-auto">
                            <FaCaretDown
                              style={{
                                transform: isInfoVisible
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.3s",
                              }}
                            />
                          </h3>
                        </div>

                        {isInfoVisible && (
                          <div className="form-content border-top-title">
                            <div class="panel panel-success my-2">
                              <div class="panel-heading py-2 px-4">
                                Fill in your contact details. Not all fields are
                                mandatory.
                              </div>
                            </div>
                            <div className="form-group my-3">
                              <label htmlFor="inputProfilePicture">Profile Image:</label>
                              <input
                                type="file"
                                className="form-control form-border"
                                id="inputProfilePicture"
                                name="img"
                                accept="image/*"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleImageUpload}
                              />
                              <div onClick={() => fileInputRef.current.click()} className="ps-0 form-selected-image position-relative">
                                {businessdata.img ? (
                                  <div className="user-img">
                                    <img
                                      src={businessdata.img}
                                      alt="Profile"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                        border: "2px solid #d5d2d2",
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div className="image-upload ps-0">
                                    <div className="user-img">
                                      <img src={user} alt="Default User" />

                                    </div>
                                  </div>
                                )}
                                <div className="fa-icon-pen">
                                  <i className="fa-solid fa-pen"></i>
                                </div>
                              </div>
                              {showCropModal && (
                                <div class="modal profile-img-select-modal">
                                  <div class="modal-wrapper">
                                    <div class="modal-content">
                                      {/* <div class="modal-head d-flex">
                                        <h5>
                                          Add Product/Service
                                        </h5>
                                        <button
                                          type="button"
                                          class="btn-close ms-auto"
                                          onClick={() => setIsModalOpen(false)}
                                        ></button>
                                      </div> */}

                                      <div class="modal-body">
                                        <ReactCrop
                                          crop={crop}
                                          onChange={(newCrop) => setCrop(newCrop)}
                                          aspect={1 / 1}
                                          circularCrop
                                        >
                                          <img
                                            ref={imgRef}
                                            src={src}
                                            alt="Crop"
                                            style={{ maxWidth: "100%", maxHeight: "400px" }}
                                            onLoad={onImageLoad}
                                          />
                                        </ReactCrop>

                                      </div>
                                      <div class="footer d-flex justify-content-around">
                                        <button type="submit" class="btn ls-btn main-btn"
                                          onClick={() => {
                                            setShowCropModal(false);
                                            fileInputRef.current.value = null;
                                            setSrc(null);
                                          }}
                                        >
                                          Cancel
                                        </button>

                                        <button type="button" class="btn ls-btn main-btn"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleCropComplete();
                                          }}
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                // Old
                                // <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                //   <div className="bg-white p-4 rounded-lg max-w-lg w-full">
                                //     <h4 className="text-lg font-semibold mb-4">Crop Image</h4>
                                //     <ReactCrop
                                //       crop={crop}
                                //       onChange={(newCrop) => setCrop(newCrop)}
                                //       aspect={1 / 1}
                                //       circularCrop
                                //     >
                                //       <img
                                //         ref={imgRef}
                                //         src={src}
                                //         alt="Crop"
                                //         style={{ maxWidth: "100%", maxHeight: "400px" }}
                                //       />
                                //     </ReactCrop>
                                //     <div className="flex justify-end mt-4">
                                //       <button
                                //         className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
                                //         onClick={() => {
                                //           setShowCropModal(false);
                                //           fileInputRef.current.value = null;
                                //           setSrc(null);
                                //         }}
                                //       >
                                //         Cancel
                                //       </button>
                                //       <a
                                //         href="#"
                                //         className="btn ls-btn main-btn ms-auto"
                                //         onClick={(e) => {
                                //           e.preventDefault();
                                //           handleCropComplete();
                                //         }}
                                //       >
                                //         Save
                                //       </a>
                                //     </div>
                                //   </div>
                                // </div>
                              )}
                            </div>
                            <div class="form-group my-3">
                              <label for="inputFullName">
                                Full Name:{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className=" form-control form-border"
                                id="inputFullName"
                                placeholder="Full Name"
                                name="full_name"
                                onChange={handleInputChange}
                                value={businessdata.full_name}
                              />
                              {formErrors.full_name && (
                                <div className="invalid-feedback d-block">
                                  {formErrors.full_name}
                                </div>
                              )}
                            </div>
                            <div className="row form-row my-3">
                              <div className="form-group col-md-6">
                                <label htmlFor="inputMobileNumber">
                                  Mobile Number:
                                </label>
                                <input
                                  type="text"
                                  className=" form-control form-border"
                                  id="inputMobileNumber"
                                  placeholder="Mobile Number"
                                  name="phone"
                                  onChange={handleInputChange}
                                  maxLength="10"
                                  value={businessdata.phone}
                                  onKeyPress={_onlyNumber}
                                />
                              </div>
                              <div className="form-group col-md-6">
                                <label htmlFor="inputEmail">Email:</label>
                                <input
                                  type="text"
                                  className="form-control form-border"
                                  id="inputEmail"
                                  placeholder="Email"
                                  name="email"
                                  onChange={handleInputChange}
                                  value={businessdata.email}

                                />
                                {formErrors.email && (
                                  <div className="invalid-feedback d-block">{formErrors.email}</div>
                                )}
                              </div>
                            </div>

                            <div className="row form-row my-3">
                              <div className="form-group col-md-6">
                                <label htmlFor="inputCompany">Company:</label>
                                <input
                                  type="text"
                                  className="form-control form-border"
                                  id="inputCompany"
                                  placeholder="Company"
                                  name="company_name"
                                  onChange={handleInputChange}
                                  value={businessdata.company_name}
                                />
                              </div>
                              <div className="form-group col-md-6">
                                <label htmlFor="inputJob">Your Job:</label>
                                <input
                                  type="text"
                                  className="form-control form-border"
                                  id="inputJob"
                                  placeholder="Your Job"
                                  name="designation"
                                  onChange={handleInputChange}
                                  value={businessdata.designation}
                                />
                              </div>
                            </div>

                            <div className="form-group my-3">
                              <label htmlFor="inputAddress">Address:</label>
                              <input
                                type="text"
                                className="form-control form-border"
                                id="inputAddress"
                                placeholder="Address"
                                name="address"
                                onChange={handleInputChange}
                                value={businessdata.address}
                              />
                            </div>

                            <div className="form-group my-3">
                              <div className="d-flex">
                                <label htmlFor="inputWebsite">Website:</label>
                                <div className="fa-icon-plus ms-auto me-2">
                                  <i
                                    class="fa-solid fa-plus"
                                    type="button"
                                    onClick={addWebsiteField}
                                  ></i>
                                </div>
                              </div>

                              {Array.isArray(businessdata.websites) &&
                                businessdata.websites.map((website, index) => (
                                  <div key={index} className="input-group mb-2 align-items-center gap-2">
                                    {faviconErrors[index] || !website ? (
                                      <TbWorldWww
                                        style={{ width: "20px", height: "20px", marginTop: "8px" }}
                                      />
                                    ) : (
                                      <img
                                        src={`https://www.google.com/s2/favicons?sz=32&domain_url=${website}`}
                                        alt="favicon"
                                        className="me-2"
                                        style={{ width: "20px", height: "20px" }}
                                        onError={() => handleFaviconError(index)}
                                      />
                                    )}

                                    <input
                                      type="text"
                                      className="form-control form-border position-relative"
                                      placeholder="www.your-website.com"
                                      value={website}
                                      onChange={(e) => handleWebsiteChange(index, e)}
                                    />
                                    <div className="plus-minus">
                                      <div
                                        className="fa-icon-minus cursor-pointer"
                                        onClick={() => handleRemoveWebsite(index)}
                                      >
                                        <i className="fa-solid fa-minus"></i>
                                      </div>
                                    </div>
                                  </div>
                                ))}


                            </div>



                            <div className="form-group my-3">
                              <label htmlFor="inputAddress2">Summary:</label>
                              <textarea
                                type="text"
                                className="form-control form-border"
                                id="inputAddress2"
                                rows="3"
                                placeholder="Enter any notes"
                                name="note"
                                onChange={handleInputChange}
                                value={businessdata.note}
                              />
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="accordion my-4 border-bottom">
                        <div
                          className="d-flex title"
                          onClick={() => handleSectionToggle("social")}>
                          <h3 className="accordion-title">Social Media</h3>
                          <h3 className="ms-auto">
                            <FaCaretDown
                              style={{
                                transform: isSocialMediaVisible
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.3s",
                              }}
                            />
                          </h3>
                        </div>

                        {isSocialMediaVisible && (
                          <div className="form-content border-top-title mb-3">
                            <div className="panel panel-success my-2">
                              <div className="panel-heading py-2 px-4">
                                Click on the icon to add social media channel.
                              </div>
                            </div>

                            <div className="">

                              {links.map((social, index) => {
                                const { label, placeholder, icon } =
                                  platformData[social.platform] || {};
                                return (
                                  <div key={index} className="social-media">
                                    <div className="">
                                      {icon && (
                                        <span className="media-icon">
                                          {icon}
                                        </span>
                                      )}
                                    </div>

                                    <div className="horizontal-border"></div>
                                    <div className="input-unset username">
                                      <div className="d-flex align-items-center">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={links[index].link}
                                          name="links"
                                          onChange={(e) =>
                                            handleSocialMediaChange(
                                              index,
                                              e.target.value
                                            )
                                          }
                                          placeholder={placeholder}
                                        />
                                        <div>
                                          <AiOutlineClose
                                            onClick={() =>
                                              removeSocialMediaLink(index)
                                            }
                                            className="close-icon"
                                          />
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                );
                              })}


                            </div>
                            <div className="add-more-button pt-2 pb-3">
                              <a onClick={toggleIconList} className="cursor-pointer">
                                {isIconListVisible ? "Hide Icons" : "Add Link"}
                              </a>
                            </div>
                            {isIconListVisible && (
                              <ul className="grid-social-media row ps-0 w-100">
                                <div className="social-icons-col mb-4">
                                  <FaGlobe
                                    onClick={() => addSocialMediaLink("Website")}
                                    style={{ ...iconStyles, color: "#000000", opacity: links.some(link => link.platform === "Website") ? 0.5 : 1, }}
                                    title="Website"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaXTwitter
                                    onClick={() => addSocialMediaLink("Twitter")}
                                    style={{ ...iconStyles, color: "#000000", height: "28px", width: "28px", opacity: links.some(link => link.platform === "Twitter") ? 0.5 : 1, }}
                                    title="Twitter"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaInstagram
                                    onClick={() =>
                                      addSocialMediaLink("Instagram")
                                    }
                                    style={{ ...iconStyles, color: "#E4405F", opacity: links.some(link => link.platform === "Instagram") ? 0.5 : 1, }}
                                    title="Instagram"
                                    className="social-icon"
                                  />
                                </div>

                                <div className="social-icons-col mb-4">
                                  <FaYoutube
                                    onClick={() => addSocialMediaLink("YouTube")}
                                    style={{ ...iconStyles, color: "#FF0000", opacity: links.some(link => link.platform === "YouTube") ? 0.5 : 1, }}
                                    title="YouTube"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaWhatsapp
                                    onClick={() => addSocialMediaLink("WhatsApp")}
                                    style={{ ...iconStyles, color: "#25D366", opacity: links.some(link => link.platform === "WhatsApp") ? 0.5 : 1, }}
                                    title="WhatsApp"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaFacebook
                                    onClick={() => addSocialMediaLink("Facebook")}
                                    style={{ ...iconStyles, color: "#1877F2", opacity: links.some(link => link.platform === "Facebook") ? 0.5 : 1, }}
                                    title="Facebook"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaSnapchat
                                    onClick={() => addSocialMediaLink("Snapchat")}
                                    style={{ ...iconStyles, color: "#FFFC00", opacity: links.some(link => link.platform === "Snapchat") ? 0.5 : 1, }}
                                    title="Snapchat"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaPinterest
                                    onClick={() =>
                                      addSocialMediaLink("Pinterest")
                                    }
                                    style={{ ...iconStyles, color: "#E60023", opacity: links.some(link => link.platform === "Pinterest") ? 0.5 : 1, }}
                                    title="Pinterest"
                                    className="social-icon"
                                  />
                                </div>

                                <div className="social-icons-col mb-4">
                                  <FaTelegram
                                    onClick={() => addSocialMediaLink("Telegram")}
                                    style={{ ...iconStyles, color: "#0088CC", opacity: links.some(link => link.platform === "Telegram") ? 0.5 : 1, }}
                                    title="Telegram"
                                    className="social-icon"
                                  />
                                </div>

                                <div className="social-icons-col mb-4">
                                  <FaVimeo
                                    onClick={() => addSocialMediaLink("Vimeo")}
                                    style={{ ...iconStyles, color: "#1AB7EA", opacity: links.some(link => link.platform === "Vimeo") ? 0.5 : 1, }}
                                    title="Vimeo"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaYelp
                                    onClick={() => addSocialMediaLink("Yelp")}
                                    style={{ ...iconStyles, color: "#D32323", opacity: links.some(link => link.platform === "Yelp") ? 0.5 : 1, }}
                                    title="Yelp"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaLine
                                    onClick={() => addSocialMediaLink("Line")}
                                    style={{ ...iconStyles, color: "#00C300", opacity: links.some(link => link.platform === "Line") ? 0.5 : 1, }}
                                    title="Line"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaFlickr
                                    onClick={() => addSocialMediaLink("Flickr")}
                                    style={{ ...iconStyles, color: "#FF0084", opacity: links.some(link => link.platform === "Flickr") ? 0.5 : 1, }}
                                    title="Flickr"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaXing
                                    onClick={() => addSocialMediaLink("Xing")}
                                    style={{ ...iconStyles, color: "#006F3A", opacity: links.some(link => link.platform === "Xing") ? 0.5 : 1, }}
                                    title="Xing"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaTumblr
                                    onClick={() => addSocialMediaLink("Tumblr")}
                                    style={{ ...iconStyles, color: "#35465C", opacity: links.some(link => link.platform === "Tumblr") ? 0.5 : 1, }}
                                    title="Tumblr"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaSpotify
                                    onClick={() => addSocialMediaLink("Spotify")}
                                    style={{ ...iconStyles, color: "#1DB954", opacity: links.some(link => link.platform === "Spotify") ? 0.5 : 1, }}
                                    title="Spotify"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaLinkedin
                                    onClick={() => addSocialMediaLink("LinkedIn")}
                                    style={{ ...iconStyles, color: "#0077B5", opacity: links.some(link => link.platform === "LinkedIn") ? 0.5 : 1, }}
                                    title="LinkedIn"
                                    className="social-icon"
                                  />
                                </div>
                                <div className="social-icons-col mb-4">
                                  <FaGithub
                                    onClick={() => addSocialMediaLink("GitHub")}
                                    style={{ ...iconStyles, color: "#333", opacity: links.some(link => link.platform === "GitHub") ? 0.5 : 1, }}
                                    title="GitHub"
                                    className="social-icon"
                                  />
                                </div>

                              </ul>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Ability to add Product/Service */}

                      <div className="accordion my-4 border-bottom">
                        <div
                          className="d-flex title"
                          onClick={() => handleSectionToggle("product")}>

                          <h3 className="accordion-title">Product/Services</h3>
                          <h3 className="ms-auto">
                            <FaCaretDown
                              style={{
                                transform: isProductvisible
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.3s",
                              }}
                            />
                          </h3>
                        </div>

                        {isProductvisible && (
                          <div className="form-content border-top-title">
                            <div>
                              <button
                                type="button"
                                className="btn ls-btn primary-btn my-2"
                                onClick={() => {
                                  resetForm();

                                  if (filteredUsers.length >= 3) {
                                    setShowLimitMessage(true);
                                  }
                                  else {
                                    setIsModalOpen(true);
                                  }
                                }}
                                disabled={filteredUsers.length >= 3} >

                                Add Product/Service
                              </button>

                              {showLimitMessage && filteredUsers.length >= 3 && (
                                <div className="alert alert-info mt-3">
                                  You can only add up to 3 products or services.
                                </div>
                              )}


                              {/* New modal s */}
                              {isModalOpen && (
                                <div class="modal product-serices-modal">
                                  <div class="modal-wrapper">
                                    <div class="modal-content">
                                      <div class="modal-head d-flex">
                                        <h5>
                                          Add Product/Service
                                        </h5>
                                        <button
                                          type="button"
                                          class="btn-close ms-auto"
                                          onClick={() => setIsModalOpen(false)}
                                        ></button>
                                      </div>

                                      <div class="modal-body">
                                        <form onSubmit={handleProduct}>

                                          <div className="">
                                            <div className="form-label">Select</div>
                                            <div className="product-service px-0">
                                              <div className="d-flex gap-2 align-items-center">
                                                <input
                                                  type="radio"
                                                  id="product"
                                                  name="fav_language"
                                                  value="product"
                                                  checked={productdata.flag === 0}
                                                  onChange={handleFlagChange}
                                                />
                                                <label className="form-radio" htmlFor="product">Product</label>
                                              </div>
                                              <div className="d-flex gap-2 align-items-center">
                                                <input
                                                  type="radio"
                                                  id="service"
                                                  name="fav_language"
                                                  value="service"
                                                  checked={productdata.flag === 1}
                                                  onChange={handleFlagChange}
                                                />
                                                <label className="form-radio" htmlFor="service">Service</label>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="mb-3">
                                            <label for="" class="form-label">
                                              Title: <span className="text-danger">*</span>
                                            </label>

                                            <input
                                              type="title"
                                              className="form-control form-border"
                                              id=""
                                              placeholder="Title"
                                              name="title"
                                              onChange={handleIpChange}
                                              value={productdata.title}
                                            />
                                            {formErrors.title && (
                                              <div className="text-danger">{formErrors.title}</div>
                                            )}
                                          </div>
                                          <div class="mb-3">
                                            <label
                                              for="exampleInputDescription"
                                              class="form-label">

                                              Description:
                                            </label>
                                            <input
                                              type="description"
                                              className="form-control form-border"
                                              id=""
                                              placeholder="Description"
                                              name="description"
                                              onChange={handleIpChange}
                                              value={productdata.description}
                                            />
                                          </div>

                                          <div class="mb-3">
                                            <label for="image" class="form-label">
                                              Image: <span className="text-danger">*</span>
                                            </label>

                                            <input
                                              type="file"
                                              id="imageUpload"
                                              ref={fileInputRef}
                                              accept="image/*"
                                              onChange={handleProductImageUpload}
                                              className="w-100"
                                            />
                                            {formErrors.img && <p style={{ color: 'red' }}>{formErrors.img}</p>}

                                            <img
                                              id="preview"
                                              class="square-image"
                                              style={{ display: "none" }}
                                            ></img>
                                            <div className="add-img">
                                              <img src={productdata?.img && productdata.img !== "" ? productdata.img : Imupload} alt="product" />
                                            </div>
                                          </div>
                                          <div className="">
                                          </div>
                                        </form>

                                      </div>
                                      <div class="footer d-flex">
                                        <button type="submit" class="btn ls-btn main-btn ms-auto" onClick={handleProduct} disabled={loading}>
                                          {loading ? "Submitting..." : "Submit"}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* New modal e */}


                            </div>

                            <div className="grid-container-service">
                              {filteredUsers.map((user) => (
                                <div key={user.id} className="pro-ser-card-cnt px-2">
                                  <div key={user.id} className="pro-ser-card card">
                                    <div class="product-img">
                                      <img src={user.img} alt="product" />
                                    </div>
                                    <div className="card-body">
                                      <h5 className="card-title">{user.title}</h5>
                                      <p className="card-text">
                                        {user.description}
                                      </p>
                                      <div className="pen-trash-icon">
                                        <a
                                          href="#"
                                          class=""
                                          // onClick={() => { handleEdit(user.id)setIsModalOpen(true) }>
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleEdit(user.id);
                                            setIsModalOpen(true);
                                          }}>
                                          <i class="fa-solid fa-pen-to-square"></i>
                                        </a>
                                        {/* <a href="#" class=""
                                        onClick={() => handleDelete(user.id)}>
                                        <i class="fa-solid fa-trash"></i>
                                      </a> */}
                                        <a href="#" onClick={(e) =>{
                                          e.preventDefault();
                                          openDeleteModal(user.id);
                                          }}>
                                          <i className="fa-solid fa-trash"></i>
                                        </a>
                                        {
                                          showDeleteModal && (
                                            <DeleteConfirmationModal
                                              onConfirm={confirmDelete}
                                              onCancel={closeDeleteModal}
                                            />
                                          )
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="accordion my-4 border-bottom">
                        <div
                          className="d-flex title"
                          onClick={() => handleSectionToggle("gallery")}>
                          <h3 className="accordion-title">Gallery Images</h3>
                          <h3 className="ms-auto">
                            <FaCaretDown
                              style={{
                                transform: isGalleryvisible
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.3s",
                              }}
                            />
                          </h3>
                        </div>

                        {isGalleryvisible && (
                          <div className="form-content border-top-title">
                            <div className="gallery-images">
                              {/* <a href="#" className="gallery-plus" onClick={handleAddImagesClick}>
                                <i className="fa-solid fa-plus"></i>
                                <span>Add Images</span>
                              </a> */}
                              <input
                                key={images.length}
                                type="file"
                                accept="image/*"
                                multiple
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleImageChange}
                              />
                              {/* {(images.length > 0 || businessdata?.image?.length > 0) && (
                                <a
                                  href="#"
                                  className="delete-img ms-auto text-danger"
                                  onClick={handleDeleteAll}
                                >
                                  <span className="text-danger">Delete all Images</span>
                                </a>
                              )} */}

                            </div>
                            <div className="gallary-container">
                              {images.map((img, index) => (
                                <div className="gallery-img" key={index}>
                                  <i className="fa-solid fa-xmark" onClick={() => handleRemoveImage(index)}></i>
                                  <img src={URL.createObjectURL(img)} alt={`new-image-${index}`} />
                                </div>
                              ))}
                              {Array.isArray(businessdata?.image) &&
                                businessdata.image.length > 0 &&
                                businessdata.image.map((imgUrl, index) => (
                                  <div className="gallery-img" key={`existing-${index}`}>
                                    <i className="fa-solid fa-xmark" onClick={() => handleRemoveUpdatedImage(index, imgUrl)}></i>
                                    <img src={imgUrl} alt={`existing-${index}`} />
                                  </div>
                                ))}
                              {(images.length + (businessdata?.image?.length || 0)) < 5 && (
                                <div className="gallery-img" onClick={handleAddImagesClick}>
                                  <div className="images-add">
                                    <div className="add-img-box">
                                      <i className="fa-solid fa-plus"></i>
                                      <span>Image</span>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      {/* Gallery images end*/}

                      {/* Youtube link */}
                      <div className="accordion my-4 border-bottom">
                        <div
                          className="d-flex title"
                          onClick={() => handleSectionToggle("youtube")}>
                          <h3 className="accordion-title">YouTube Link</h3>
                          <h3 className="ms-auto">
                            <FaCaretDown
                              style={{
                                transform: isYouTubeVisible
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.3s",
                              }}
                            />
                          </h3>
                        </div>
                        {isYouTubeVisible && (
                          <div class="form-content form-group border-top-title  my-3">
                            <label for="inputFullName" className="ms-2">
                              Add youtube link:
                            </label>
                            <input
                              type="text"
                              className=" form-control form-border"
                              id="inputFullName"
                              placeholder="Enter YouTube link"
                              name="youtube_link"
                              onChange={handleInputChange}
                              value={businessdata.youtube_link}
                            />
                            {/* <div className=" grid-youtube">
                              <div class=" youtube-video">
                                <div className="youtube-add">
                                  <div className="add-youtube-box">
                                    <i class="fa-brands fa-youtube"></i>
                                  </div>
                                </div>
                                <div className="pen-trash-view">
                                  <a
                                    href="#"
                                    class=""
                                    data-bs-toggle="modal"
                                    data-bs-target="#staticBackdrop"
                                  >
                                    <i class="fa-solid fa-pen-to-square"></i>
                                  </a>
                                  <a href="#" class="">
                                    <i class="fa-solid fa-trash"></i>
                                  </a>
                                  <a href="#" class="">
                                    <i class="fa-solid fa-eye"></i>
                                  </a>
                                </div>
                              </div>
                              <div class=" grid-youtube-plus main-add-video">
                                <a href="#" class="video-add">
                                  <i class="fa-solid fa-plus"></i>
                                </a>
                                <div className="d-flex justify-content-center">
                                  Add Youtube Video
                                </div>
                              </div>
                            </div> */}
                          </div>
                        )}
                      </div>

                    </div>
                    <div className="d-flex gap-2 mt-3">
                      <button className="btn ls-btn main-btn" type="submit" disabled={loading}>
                        {loading ? "Submitting..." : "Submit"}
                      </button>

                      {/* {submitted && !id && (
                        <a
                          onClick={() => handlePublish(probId, name)}
                          className="btn ls-btn publish-btn ms-4"
                        >
                          Preview
                        </a>
                      )} */}
                    </div>
                  </form>
                  <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    closeOnClick={true}
                    pauseOnHover={true}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-5 preview ">
              <div className="vCard-body">

                <div className="vCard-container position-relative mx-auto">
                  <div className="iphone-camera">
                    {/* <div className="i-comera"></div> */}
                  </div>
                  <div className="vCard">
                    <div className="vHead">
                      <div className="bg-shape"></div>
                      <div className="head-info">
                        <h2>{businessdata?.full_name || "Name"}</h2>
                        <div className="profile">
                          {businessdata && businessdata.img ? (
                            <img
                              src={businessdata.img}
                              alt="logo"
                              style={{
                                width: "100%",
                                height: "100%",
                              }}
                            />
                          ) : (
                            <img
                              src={
                                businessdata.img
                                  ? `${businessdata.img}`
                                  : `${no_user}`
                              }
                              alt="logo"
                              style={{
                                width: "100%",
                              }}
                            />
                          )}
                        </div>
                        <div className="com-pos">
                          {/* <p>
                            {businessdata?.designation ||
                              " Chief Administrative Officer"}
                            <br />
                            at{" "}
                            <strong>
                              {businessdata?.company_name ||
                                "Aspirewebs & Informatics Pvt. Ltd."}
                            </strong>
                          </p> */}
                          <p>
                            {businessdata?.designation}
                            <br />
                            at{" "}
                            <strong>
                              {businessdata?.company_name}
                            </strong>
                          </p>
                        </div>
                        <div className="contacts">
                          <ul>
                            <li>
                              <Link
                                to={`tel:${businessdata.phone}`}
                                className="contact-card"
                              >
                                <i className="icon-phone"></i>
                                Call Us
                              </Link>
                            </li>
                            <li>
                              <Link
                                to={`https://wa.me/${businessdata.phone}`}
                                target="_blank"
                                className="contact-card">
                                <i className="icon-whatsapp"></i>
                                Whatsapp
                              </Link>
                            </li>
                            <li>
                              <Link
                                to={`https://maps.google.com/?q=${encodeURIComponent(
                                  businessdata.address
                                )}`}
                                target="_blank"
                                className="contact-card"
                              >
                                <i className="icon-direction"></i>
                                Direction
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="vBody">
                      {businessdata.note && (
                        <div className="vCard-about">
                          <h3>About me</h3>
                          {/* <p>
                          {businessdata?.note ||
                            "I'm Abc, a dedicated software developer specializing in web and mobile app development. Passionate about creating innovative solutions and building meaningful connections."}
                        </p> */}
                          <p>{businessdata.note}</p>
                        </div>
                      )}
                      <div className="vCard-d">
                        {businessdata.phone && (
                          <div className="d-item">
                            <i className="icon-phone"></i>
                            <span>Mobile</span>
                            {/* <h2>
                            <Link
                              to={`tel:${businessdata?.phone || "1234567890"}`}
                            >
                              {businessdata?.phone || "0000000000"}
                            </Link>
                          </h2> */}
                            <h2>
                              <Link
                                to={`tel:${businessdata?.phone || "1234567890"}`}>
                                {businessdata.phone}
                              </Link>
                            </h2>
                          </div>
                        )}
                        {businessdata.email && (
                          <div className="d-item">
                            <i className="icon-envelope"></i>
                            <span>Email</span>
                            {/* <h2>
                            <Link
                              to={`mailto:${businessdata?.email || "example@example.com"
                                }`}
                            >
                              {businessdata?.email || "user@example.com"}
                            </Link>
                          </h2> */}
                            <h2>
                              <Link
                                to={`mailto:${businessdata?.email || "example@example.com"
                                  }`}>

                                {businessdata.email}
                              </Link>
                            </h2>
                          </div>
                        )}
                        {businessdata.address && (
                          <div className="d-item">
                            <i className="icon-location"></i>
                            <span>Location</span>
                            {/* <h2>
                            <Link
                              to={`https://maps.google.com/?q=${encodeURIComponent(
                                businessdata.address
                              )}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {businessdata?.address || "India"}
                            </Link>
                          </h2> */}
                            <h2>
                              <Link
                                to={`https://maps.google.com/?q=${encodeURIComponent(
                                  businessdata.address
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {businessdata.address}
                              </Link>
                            </h2>
                          </div>
                        )}

                        {businessdata.company_name && (
                          <div className="d-item">
                            <i className="icon-briefcase"></i>
                            <span>
                              {businessdata?.designation || "Job Role"}
                            </span>
                            <h2>
                              <Link
                                to={formatCompanyURL(businessdata.company_name)}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {businessdata?.company_name}
                              </Link>
                            </h2>
                          </div>
                        )}
                      </div>
                      {Array.isArray(businessdata.websites) &&
                        businessdata.websites.filter(site => site?.trim()).length > 0 && (
                          <div className="sites">
                            <div>
                              <h3>Websites</h3>
                            </div>
                            {businessdata.websites.map((website, index) => {
                              if (!website?.trim()) return null;

                              const websiteUrl =
                                website.startsWith("http://") || website.startsWith("https://")
                                  ? website
                                  : `https://${website}`;

                              return (
                                <div key={index} className="d-item">
                                  <div className="site-list d-flex flex-column">
                                    <div className="d-flex">
                                      <div className="site-logo">
                                        {/* <img
                                          src="https://cdn0.iconfinder.com/data/icons/social-circle-3/72/Codepen-512.png"
                                          width="100%"
                                          height="100%"
                                          alt="website logo"
                                        /> */}
                                        {faviconErrors[index] || !website ? (
                                          <TbWorldWww
                                            style={{ width: "20px", height: "20px", marginRight: "8px" }}
                                          />
                                        ) : (
                                          <img
                                            src={`https://www.google.com/s2/favicons?sz=32&domain_url=${website}`}
                                            alt="favicon"
                                            className="me-2"
                                            style={{ width: "20px", height: "20px" }}
                                            onError={() => handleFaviconError(index)}
                                          />
                                        )}
                                      </div>
                                      <div className="website-url ms-2">
                                        <Link
                                          to={websiteUrl}
                                          className="text-decoration-none"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {website}
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}


                      {Array.isArray(links) && links.filter(link => link?.link?.trim()).length > 0 && (
                        <div className="social">
                          <h3>Connect us</h3>
                          {links.map((link, index) => {
                            if (!link?.link?.trim()) return null;
                            const generateFullUrl = (platform, link) => {
                              if (link.startsWith("http://") || link.startsWith("https://")) {
                                return link;
                              }
                              switch (platform) {
                                case "Website":
                                  return `https://google.com/search?q=${link}`;
                                case "Facebook":
                                  return `https://facebook.com/${link}`;
                                case "Twitter":
                                  return `https://twitter.com/${link}`;
                                case "Instagram":
                                  return `https://instagram.com/${link}`;
                                case "LinkedIn":
                                  return `https://linkedin.com/in/${link}`;
                                case "YouTube":
                                  return `https://youtube.com/c/${link}`;
                                case "GitHub":
                                  return `https://github.com/${link}`;
                                case "WhatsApp":
                                  return `https://wa.me/${link}`;
                                case "Snapchat":
                                  return `https://snapchat.com/add/${link}`;
                                case "Pinterest":
                                  return `https://pinterest.com/${link}`;
                                case "Telegram":
                                  return `https://t.me/${link}`;
                                case "Tiktok":
                                  return `https://tiktok.com/@${link}`;
                                case "Yelp":
                                  return `https://yelp.com/biz/${link}`;
                                case "Vimeo":
                                  return `https://vimeo.com/biz/${link}`;
                                case "Line":
                                  return `https://line.me/ti/p/${link}`;
                                case "Flickr":
                                  return `https://flickr.com/photos/${link}`;
                                case "Xing":
                                  return `https://xing.com/profile/${link}`;
                                case "Tumblr":
                                  return `https://tumblr.com/blog/${link}`;
                                case "Spotify":
                                  return `https://open.spotify.com/user/${link}`;
                                default:
                                  return link;
                              }
                            };

                            const fullLink = generateFullUrl(link.platform, link.link);

                            return (
                              <div
                                key={index}
                                style={{
                                  margin: "10px",
                                  display: "inline-block",
                                }}>

                                <a
                                  href={fullLink}
                                  target="_blank"
                                  rel="noopener noreferrer">
                                  {Object.entries(platformData).map(
                                    ([key, item]) =>
                                      link.platform === key && (
                                        <div key={key}>{item.icon}</div>
                                      )
                                  )}
                                </a>
                              </div>
                            );
                          })}
                        </div>
                      )}

                      {/* <div className="product-service vcard-border-top">
                        <div className="d-flex flex-column">
                           {filteredUsers.some(user => user.flag === 0) && (
                            <>
                          <div>
                            <h3 className="section-header">Products</h3>
                          </div>
                          <div className="product-service-cards d-flex flex-wrap">
                            {filteredUsers.filter(user => user.flag === 0).map((user, index) => (
                              <div key={`product-${index}`} className="w-50 p-1">
                                <div className="product-service-card position-relative">
                                  <div className="pro-ser-img w-100">
                                    <img src={user.img} alt="product" className="w-100" />
                                  </div>

                                  {user.jr && (
                                    <div className="card-body">
                                      <h5 className="card-title">{user.title}</h5>
                                      <p className="card-text">{user.description}</p>
                                    </div>
                                 
                                </div>
                              </div>
                            ))}
                              </div>
                            </>
                          )}
                           {filteredUsers.some(user => user.flag !== 0) && (
                            <>
                          <div className="mt-4">
                            <h3 className="section-header">Services</h3>
                          </div>
                          <div className="product-service-cards d-flex flex-wrap">
                            {filteredUsers.filter(user => user.flag !== 0).map((user, index) => (
                              <div key={`service-${index}`} className="w-50 p-1">
                                <div className="product-service-card position-relative">
                                  <div className="pro-ser-img w-100">
                                    <img src={user.img} alt="service" className="w-100" />
                                  </div>
                                  {user.jr && (

                                  <div className="badge position-absolute badge-service">Service</div>

                                    <div className="card-body">
                                      <h5 className="card-title">{user.title}</h5>
                                      <p className="card-text">{user.description}</p>
                                    </div>
                                  
                                </div>
                              </div>
                            ))}
                            </div>
                            </>
                          )}
                        </div>
                      </div> */}

                      {filteredUsers.some(user => user.flag === 0) && (
                        <div className="product-service vcard-border-top">
                          <div className="d-flex flex-column">
                            <>
                              <div>
                                <h3 className="section-header">Products</h3>
                              </div>
                              <div className="product-service-cards d-flex flex-wrap">
                                {filteredUsers.filter(user => user.flag === 0).map((user, index) => (
                                  <div key={`product-${index}`} className="w-50 p-1">
                                    <div className="product-service-card position-relative">
                                      <div className="pro-ser-img w-100">
                                        <img src={user.img} alt="product" className="w-100" />
                                      </div>
                                      {user.title && (
                                        <div className="card-body">
                                          <h5 className="card-title">{user.title}</h5>
                                          <p className="card-text">{user.description}</p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </>
                          </div>
                        </div>
                      )}


                      {filteredUsers.some(user => user.flag !== 0) && (
                        <div className="product-service vcard-border-top">
                          <div className="d-flex flex-column">
                            <>
                              <div>
                                <h3 className="section-header">Services</h3>
                              </div>
                              <div className="product-service-cards d-flex flex-wrap">
                                {filteredUsers.filter(user => user.flag !== 0).map((user, index) => (
                                  <div key={`service-${index}`} className="w-50 p-1">
                                    <div className="product-service-card position-relative">
                                      <div className="pro-ser-img w-100">
                                        <img src={user.img} alt="service" className="w-100" />
                                      </div>
                                      {user.title && (
                                        <div className="card-body">
                                          <h5 className="card-title">{user.title}</h5>
                                          <p className="card-text">{user.description}</p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </>
                          </div>
                        </div>
                      )}

                      {Array.isArray(fullImageList) && fullImageList.length > 0 && (
                        <div className="gallary vcard-border-top">
                          <div className="d-flex flex-column">
                            <div className="d-flex position-relative">
                              <h3 className="">Gallery</h3>
                            </div>
                            <div className="d-flex flex-wrap">
                              {fullImageList.slice(0, 5).map((img, index) => (
                                <div
                                  className="w-50 p-1"
                                  key={index}
                                  onClick={() => handleImageClick(index)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    className="w-100 rounded-2"
                                    src={typeof img === "string" ? img : URL.createObjectURL(img)}
                                    alt={`Gallery preview ${index}`}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                      {/*Gallery modal new*/}
                      {previewIndex !== null && (
                        <div className="gallery-modal-overlay">
                          <div className="modal-body">
                            <button
                              onClick={closePreview}
                              className="btn-img-close"
                              style={{ zIndex: 1 }}
                            >
                              <i className="icon-cancel d-flex"></i>
                            </button>

                            <div className="modal-body-content">
                              <div
                                className="slider-img"
                                ref={containerRef}
                                onWheel={handleWheel}
                                onMouseDown={onMouseDown}
                                onMouseMove={onMouseMove}
                                onMouseUp={onMouseUp}
                                onMouseLeave={onMouseUp}
                              >
                                {/* If using Next.js, keep <Image>. Otherwise use <img> */}
                                <img
                                  ref={imageRef}
                                  className="max-h-full cursor-pointer"
                                  src={fullImageList[previewIndex]}
                                  alt="Preview"
                                  width={500}
                                  height={350}
                                  style={{ objectFit: 'contain', ...transformStyle }}
                                  onError={(e) => {
                                    e.target.src = '/path/to/default.jpg';
                                  }}
                                />
                              </div>

                              {fullImageList.length > 1 && (
                                <div className="slider-nav">
                                  <button
                                    onClick={showPreviousImage}
                                    className="arrow-btn arrow-left-btn"
                                  >
                                    <i className="icon-left-open me-1"></i>
                                  </button>
                                  <button
                                    onClick={showNextImage}
                                    className="arrow-btn arrow-right-btn"
                                  >
                                    <i className="icon-right-open ms-1"></i>
                                  </button>
                                </div>
                              )}

                              <div className="action-btns">
                                <button onClick={zoomOut} className="" title="Zoom Out">
                                  <i className="icon-zoom-out"></i>
                                </button>
                                <button onClick={zoomIn} className="" title="Zoom In">
                                  <i className="icon-zoom-in"></i>
                                </button>
                                <button onClick={rotateLeft} className="" title="Rotate Left">
                                  <i className="icon-arrow-rotate-left-icon"></i>
                                </button>
                                <button onClick={rotateRight} className="" title="Rotate Right">
                                  <i className="icon-arrow-rotate-right-icon"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {videoId && (
                        <div className="yt-videos vcard-border-top">
                          <div className="d-flex flex-column">
                            <div>
                              <h3 className="">Video</h3>
                            </div>
                            {videoId && (
                              <div className="d-flex">
                                <div className="video-cnt w-100 px-1">
                                  <iframe
                                    width="100%"
                                    height="100%"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allowFullScreen
                                    title="YouTube Preview"
                                  ></iframe>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="wp-enquiry-form pt-3 pb-4 vcard-border-top">
                        <div className="wp-enquiry-form-body d-flex w-100 flex-column p-4 rounded-2">
                          <div>
                            <h3 className="mb-0">Enquiry form</h3>
                          </div>
                          <form className="w-100" autocomplete="off" onSubmit={handleWhatsapp}>
                            <div class="w-100 mb-2">
                              <div class="form-group">
                                <div class="form-field">
                                  <label>Name</label>
                                  <input type="text"
                                    class="form-control border-bottom px-0 mt-0"
                                    placeholder="Name"
                                    value={whatsappname}
                                    onChange={(e) => setWhatsappName(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="w-100 mb-2">
                              <div class="form-group">
                                <div class="form-field">
                                  <label>Mobile number</label>
                                  <input type="tel"
                                    class="form-control border-bottom px-0 mt-0"
                                    placeholder="Mobile number"
                                    value={mobile}
                                    maxLength="10"
                                    onChange={handleMobileChange}
                                  />
                                  {mobileError && (
                                    <small className="text-danger">{mobileError}</small>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div class="w-100 mb-2">
                              <div class="form-group">
                                <div class="form-field">
                                  <label>Message</label>
                                  <textarea type="password"
                                    rows={3}
                                    class="form-control border-bottom px-0 mt-0"
                                    placeholder="Message"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="w-100">
                              <div class="form-group">
                                <div class="form-field border-0 d-flex">
                                  <button
                                    type="submit"
                                    className="btn ls-btn main-btn mx-auto"
                                    disabled={!isFormValid}
                                    style={{
                                      opacity: isFormValid ? 1 : 0.5,
                                      cursor: isFormValid ? "pointer" : "not-allowed",
                                    }}
                                  >
                                    <RiSendPlaneFill />
                                    &nbsp;Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BusinessForm;